<template>
  <b-card body-class="py-3" class="card-box card__part-description w-100">
    <b-card-body body-class="p-0 d-flex align-items-start justify-content-between">
      <base-text-editor-display class="pt-2">
        <span
          ref="text__part-description"
          v-safe-html="partDescription"
          class="text__part-description"
        />
      </base-text-editor-display>

      <base-ellipsis
        v-if="editable"
        ref="dropdown__part-description"
        class="dropdown__part-description"
        :disabled="disabled"
      >
        <b-dropdown-item
          :ref="`button__edit-description-part-${part}`"
          class="button__edit-description"
          :to="partDescriptionPage"
        >
          Edit
        </b-dropdown-item>
      </base-ellipsis>
    </b-card-body>
  </b-card>
</template>

<script>
import LearningUnit from '@/models/LearningUnit';
import BaseEllipsis from '@/components/base-components/BaseEllipsis';
import BaseTextEditorDisplay from '@/components/base-components/BaseTextEditorDisplay';

export default {
  components: {
    BaseEllipsis,
    BaseTextEditorDisplay
  },
  props: {
    learningUnit: {
      type: LearningUnit,
      required: true
    },

    part: {
      type: String,
      required: true
    },

    disabled: {
      type: [Number, Boolean],
      default: false
    },

    editable: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    partDescription() {
      return this.learningUnit.partDescription(this.part);
    },

    partDescriptionPage() {
      return {
        name: 'learning-unit/part/description',
        params: {
          learningUnitId: this.learningUnit.id,
          partType: this.part
        },
        query: {
          previousPath: this.$route.fullPath
        }
      };
    }
  }
};
</script>

<style lang="scss">
.text__part-description {
  p {
    margin-bottom: 0;
  }
}

.card__part-description {
  max-width: 910px;
  margin: auto;
}
</style>
